import * as types from "../constTypes";

const initialState = {};

export const auctionList = (state = initialState, action) => {
  switch (action.type) {
    case types.flowTypes.AUCTIONS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
